<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Centros de Costos</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Operación</li>
                  <li class="breadcrumb-item active">Centros de Costos</li>
                  <li class="breadcrumb-item active">
                    Formulario Centros de Costos
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="col-6 pt-2 pb-2">
                <h5 class="mb-0" v-if="isCreate">
                  Formulario crear Centros de Costos
                </h5>
                <h5 class="mb-0" v-if="!isCreate">
                  Formulario editar Centros de Costos
                </h5>
              </div>
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    id="tab-Principal"
                    data-toggle="tab"
                    href="#Principal"
                    >Principal</a
                  >
                </li>
              </ul>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade active show" id="Principal">
                  <div class="card-body">
                    <div class="row justify-content-center">
                      <div class="form-group col-md-2">
                        <label for="nombres">Pais</label>
                        <select
                          class="form-control form-control-sm"
                          v-model="form.pais_id"
                          :class="
                            $v.form.pais_id.$invalid ? 'is-invalid' : 'is-valid'
                          "
                        >
                          <option value="">Seleccione...</option>
                          <option
                            v-for="pais in listasForms.paises"
                            :key="pais.id"
                            :value="pais.id"
                          >
                            {{ pais.nombre }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-2">
                        <label for="nombres">Tipo Bloque</label>
                        <v-select
                          class="form-control form-control-sm p-0"
                          v-model="tipo_bloque"
                          placeholder="Tipo Bloque"
                          :options="listasForms.tipos_bloques"
                          label="descripcion"
                          @input="onChangeTipoBloque()"
                          :disabled="!form.pais_id"
                          :class="
                            $v.tipo_bloque.$invalid ? 'is-invalid' : 'is-valid'
                          "
                        >
                        </v-select>
                      </div>
                      <div class="form-group col-md-3">
                        <label for="nombres">Bloque</label>
                        <v-select
                          class="form-control form-control-sm p-0"
                          v-model="bloque"
                          placeholder="Bloques"
                          :options="listasForms.bloques_X_tipos"
                          label="nombre"
                          @input="getSelectBloque()"
                          :disabled="!tipo_bloque"
                          :class="
                            $v.form.bloque_id.$invalid
                              ? 'is-invalid'
                              : 'is-valid'
                          "
                        >
                        </v-select>
                      </div>
                      <div class="form-group col-md-2">
                        <label for="nombres">Tipo Sitio</label>
                        <select
                          class="form-control form-control-sm"
                          v-model="form.sitio_type"
                          :disabled="!form.bloque_id"
                          :class="
                            $v.form.sitio_type.$invalid
                              ? 'is-invalid'
                              : 'is-valid'
                          "
                          @change="onChangeTipoSitio()"
                        >
                          <option value="">Seleccione...</option>
                          <option
                            v-for="tipoSitio in listasForms.tipos_Sitios"
                            :key="tipoSitio.id"
                            :value="tipoSitio.cod_alterno"
                          >
                            {{ tipoSitio.descripcion }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-3">
                        <label for="nombres">Sitio</label>
                        <v-select
                          class="form-control form-control-sm p-0"
                          v-model="sitio"
                          placeholder="Sitios"
                          :options="listasForms.sitios"
                          label="nombre"
                          :class="
                            $v.form.sitio_id.$invalid
                              ? 'is-invalid'
                              : 'is-valid'
                          "
                          :disabled="!form.sitio_type"
                          @input="getSelectSitio()"
                        >
                        </v-select>
                      </div>
                      <div class="form-group col-md-3">
                        <label for="nombres">Codigo Contable</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          :class="
                            $v.form.codigo_contable.$invalid
                              ? 'is-invalid'
                              : 'is-valid'
                          "
                          id="nombres"
                          v-model="form.codigo_contable"
                        />
                      </div>
                      <div class="form-group col-md-3">
                        <label for="nombres">Area</label>
                        <select
                          class="form-control form-control-sm"
                          v-model="form.area"
                          :class="
                            $v.form.area.$invalid ? 'is-invalid' : 'is-valid'
                          "
                        >
                          <option value="">Seleccione...</option>
                          <option
                            v-for="area in listasForms.areas"
                            :key="area.numeracion"
                            :value="area.numeracion"
                          >
                            {{ area.descripcion }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-3">
                        <label for="nombres">Presupuesto</label>
                        <input
                          type="number"
                          class="form-control form-control-sm"
                          :class="
                            $v.form.presupuesto.$invalid
                              ? 'is-invalid'
                              : 'is-valid'
                          "
                          id="nombres"
                          v-model="form.presupuesto"
                        />
                      </div>
                      <div class="form-group col-md-3">
                        <label for="nombres">Activo</label>
                        <select
                          class="form-control form-control-sm"
                          v-model="form.activo_id"
                          :class="
                            $v.form.activo_id.$invalid
                              ? 'is-invalid'
                              : 'is-valid'
                          "
                        >
                          <option value="">Seleccione...</option>
                          <option
                            v-for="activo in listasForms.activos"
                            :key="activo.numeracion"
                            :value="activo.numeracion"
                          >
                            {{ activo.descripcion }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-3">
                        <label for="nombres">Sociedad Presupuesto</label>
                        <select
                          class="form-control form-control-sm"
                          v-model="form.sociedad_presupuesto_id"
                          :class="
                            $v.form.sociedad_presupuesto_id.$invalid
                              ? 'is-invalid'
                              : 'is-valid'
                          "
                        >
                          <option value="">Seleccione...</option>
                          <option
                            v-for="sociedad_presupuesto in listasForms.sociedad_presupuesto"
                            :key="sociedad_presupuesto.numeracion"
                            :value="sociedad_presupuesto.numeracion"
                          >
                            {{ sociedad_presupuesto.descripcion }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-3">
                        <label for="nombres">Tipo De Presupuesto</label>
                        <select
                          class="form-control form-control-sm"
                          v-model="form.tipo_presupuesto"
                          :class="
                            $v.form.tipo_presupuesto.$invalid
                              ? 'is-invalid'
                              : 'is-valid'
                          "
                        >
                          <option value="">Seleccione...</option>
                          <option
                            v-for="presupuesto in listasForms.tipo_presupuesto_contable"
                            :key="presupuesto.numeracion"
                            :value="presupuesto.numeracion"
                          >
                            {{ presupuesto.descripcion }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-6">
                        <label for="nombres">Descripcion</label>
                        <textarea
                          type="textarea"
                          class="form-control form-control-sm"
                          rows="3"
                          id="nombres"
                          :class="
                            $v.form.descripcion.$invalid
                              ? 'is-invalid'
                              : 'is-valid'
                          "
                          v-model="form.descripcion"
                        ></textarea>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Funcionario Responsable</label>
                          <v-select
                            :class="[
                              $store.getters.getDarkMode ? 'dark-vselect' : '',
                              $v.form.funcionario_id.$invalid
                                ? 'is-invalid'
                                : 'is-valid',
                            ]"
                            class="form-control form-control-sm p-0"
                            v-model="funcionario"
                            :options="listasForms.funcionarios"
                            label="nombres"
                            @input="getSelectFuncionario()"
                          >
                          </v-select>
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="!isCreate">
                      <div class="col-md-8 offset-md-2">
                        <CecosYafesLinea
                          v-if="
                            form.id != null &&
                              $store.getters.can(
                                'admin.cecosYafes.assingOrRevokeLinea',
                              )
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="row">
                <button
                  class="btn bg-primary col-md-1"
                  v-show="!$v.$invalid"
                  @click="save()"
                >
                  <i class="fas fa-paper-plane"></i><br />Guardar
                </button>
                <button class="btn bg-secondary col-md-1" @click="back()">
                  <i class="fas fa-reply"></i><br />Volver
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import CecosYafesLinea from "./CecosYafesLinea";
import Loading from "../../../../components/Loading";
import { required } from "vuelidate/lib/validators";

export default {
  name: "CecosYafesForm",
  components: {
    Loading,
    vSelect,
    CecosYafesLinea,
  },
  data() {
    return {
      opcion: 1,
      cargando: false,
      isCreate: false,
      form: {
        funcionario_id: null,
        funcionario: {},
        codigo_contable: null,
        tipo_presupuesto: null,
        descripcion: null,
        responsable: null,
        presupuesto: null,
        bloque_type: null,
        bloque_id: null,
        pais_id: null,
        activo_id: null,
        area: null,
        sitio_type: null,
        sitio_id: null,
        sociedad_presupuesto_id: null,
      },
      funcionario: null,
      accion: "",
      metodo: "",
      bloque: null,
      sitio: null,
      tipo_bloque: null,
      listasForms: {
        tipo_presupuesto: [],
        funcionarios: [],
        tipos_bloques: [],
        bloques_X_tipos: [],
        paises: [],
        activos: [],
        areas: [],
        tipos_Sitios: [],
        sitios: [],
        sociedad_presupuesto: [],
        tipo_presupuesto_contable: [],
      },
      id: this.$route.params.id,
    };
  },
  validations: {
    tipo_bloque: {
      required,
    },
    form: {
      funcionario_id: {
        required,
      },
      codigo_contable: {
        required,
      },
      tipo_presupuesto: {
        required,
      },
      descripcion: {
        required,
      },
      responsable: {
        required,
      },
      presupuesto: {
        required,
      },
      bloque_id: {
        required,
      },
      pais_id: {
        required,
      },
      activo_id: {
        required,
      },
      area: {
        required,
      },
      sitio_type: {
        required,
      },
      sitio_id: {
        required,
      },
      sociedad_presupuesto_id: {
        required,
      },
    },
  },
  methods: {
    async init() {
      this.cargando = true;
      this.accion = this.$route.params.accion;
      this.opcion = this.$route.params.opcion;

      if (this.$route.params.accion == "Crear") {
        this.isCreate = true;
        this.metodo = "POST";
      } else {
        this.isCreate = false;
        this.metodo = "PUT";
        await this.show();
      }
      this.cargando = false;
    },

    save() {
      if (!this.$v.$invalid) {
        this.cargando = true;
        axios({
          method: this.metodo,
          url: "/api/admin/cecosYafes",
          data: this.form,
        })
          .then((response) => {
            this.form = response.data;
            this.$swal({
              icon: "success",
              title: this.isCreate
                ? "Resgitro creado exitosamente"
                : "El funcionario responsable se guardó exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.cargando = false;
          })
          .catch((e) => {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error, vuelva a intentarlo..." + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.cargando = false;
          });
      }
    },

    async show() {
      const response = await axios.get("/api/admin/cecosYafes/show/" + this.id);
      this.form = response.data;

      this.funcionario = {
        id: this.form.funcionario_id,
        nombres:
          this.form.funcionario.nombres + " " + this.form.funcionario.apellidos,
      };

      this.sitio = {
        id: this.form.sitio_id,
        nombre: this.form.sitio.nombre,
      };

      await this.resolveTipoBloque();
    },

    onChangeTipoBloque() {
      this.form.bloque_type = null;
      this.form.bloque_id = null;
      this.bloque = null;
      this.listasForms.bloques_X_tipos = [];

      if (this.tipo_bloque) {
        this.form.bloque_type = this.tipo_bloque.cod_alterno;
        this.getBloquesTipo(this.tipo_bloque);
      }
    },

    async resolveTipoBloque() {
      if (!this.form.bloque_id || !this.form.pais_id) {
        return;
      }

      for (const tipo of this.listasForms.tipos_bloques) {
        const params = {
          numero_bloque: tipo.numeracion,
          pais_id: this.form.pais_id,
        };
        const response = await axios.get("/api/admin/cecosYafes/bloquesXTipo", {
          params,
        });
        const bloque = response.data.find(
          (item) => item.id === this.form.bloque_id,
        );

        if (bloque) {
          this.tipo_bloque = tipo;
          this.form.bloque_type = tipo.cod_alterno;
          this.listasForms.bloques_X_tipos = response.data;
          this.bloque = bloque;
          return;
        }
      }
    },

    async getTiposBloques() {
      const response = await axios.get("/api/lista/233");
      this.listasForms.tipos_bloques = response.data;
    },

    getBloquesTipo(bloque) {
      if (this.form.pais_id && bloque) {
        const params = {
          numero_bloque: bloque.numeracion,
          pais_id: this.form.pais_id,
        };
        axios
          .get("/api/admin/cecosYafes/bloquesXTipo", {
            params: params,
          })
          .then((response) => {
            this.listasForms.bloques_X_tipos = response.data;
          });
      }
    },

    getTiposSitios() {
      axios.get("/api/lista/234").then((response) => {
        this.listasForms.tipos_Sitios = response.data;
      });
    },

    getTipoPresupuestoContable() {
      axios.get("/api/lista/151").then((response) => {
        this.listasForms.tipo_presupuesto_contable = response.data;
      });
    },

    async getFuncionarios() {
      await axios.get("/api/admin/funcionarios/lista").then((response) => {
        this.listasForms.funcionarios = response.data;
      });
    },

    getSelectFuncionario() {
      this.form.funcionario_id = "";
      this.form.funcionario = {};

      if (this.funcionario) {
        this.form.funcionario_id = this.funcionario.id;
        this.form.funcionario = this.funcionario;
        this.form.responsable = this.funcionario.id;
      }
    },

    getSitios(sitio) {
      if (this.form.bloque_id && sitio) {
        const params = {
          numero_sitio: sitio.numeracion,
        };

        return axios
          .get("/api/admin/cecosYafes/sitios", {
            params: params,
          })
          .then((response) => {
            this.listasForms.sitios = Array.isArray(response.data)
              ? response.data
              : [];
          });
      }

      return Promise.resolve();
    },

    getPaises() {
      axios.get("/api/admin/paises/lista").then((response) => {
        this.listasForms.paises = response.data;
      });
    },

    getArea() {
      axios.get("/api/lista/78").then((response) => {
        this.listasForms.areas = response.data;
      });
    },

    getActivos() {
      axios.get("/api/lista/230").then((response) => {
        this.listasForms.activos = response.data;
      });
    },

    getSociedadPresupuesto() {
      axios.get("/api/lista/229").then((response) => {
        this.listasForms.sociedad_presupuesto = response.data;
      });
    },

    getSelectBloque() {
      this.form.bloque_id = null;
      this.form.sitio_type = null;
      this.form.sitio_id = null;
      this.sitio = null;
      this.listasForms.sitios = [];

      if (this.bloque) {
        this.form.bloque_id = this.bloque.id;
      }
    },

    onChangeTipoSitio() {
      this.form.sitio_id = null;
      this.sitio = null;
      this.listasForms.sitios = [];

      if (!this.form.sitio_type) {
        return;
      }

      const tipoSitio = this.listasForms.tipos_Sitios.find(
        (item) => item.cod_alterno === this.form.sitio_type,
      );

      if (tipoSitio) {
        this.getSitios(tipoSitio);
      }
    },

    getSelectSitio() {
      this.form.sitio_id = null;
      if (this.sitio) {
        this.form.sitio_id = this.sitio.id;
      }
    },

    back() {
      return this.$router.replace("/Admin/CecosYafes");
    },
  },
  async mounted() {
    await this.getFuncionarios();
    await this.getTiposBloques();
    await this.getTipoPresupuestoContable();
    await this.init();
    await this.getPaises();
    await this.getArea();
    await this.getActivos();
    await this.getSociedadPresupuesto();
    await this.getTiposSitios();

    if (!this.isCreate && this.form.sitio_type) {
      const sitioSeleccionado = {
        id: this.form.sitio_id,
        nombre: this.form.sitio?.nombre,
      };
      const tipoSitio = this.listasForms.tipos_Sitios.find(
        (item) => item.cod_alterno === this.form.sitio_type,
      );

      if (tipoSitio) {
        await this.getSitios(tipoSitio);
      }

      this.sitio = sitioSeleccionado;
      this.form.sitio_id = sitioSeleccionado.id;
    }
  },
};
</script>
